"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScannerInput_1 = require("./ScannerInput");
var Util_1 = require("./Util");
var Services_1 = require("../Services");
// Set the following constant to true to force calibration based on characters rather than event codes.  
// When false, event codes will be use for browsers that support them, requiring a single barcode for calibration
var calibrationOnCharacters = "false";
// Handles barcode scanner input.
var BarcodeScannerHandler = /** @class */ (function () {
    // Initializes the barcode scanner class.
    //   submitDataFunc: A function that handles data read by the barcode scanner.  The function must take a
    //                   parameter indicating whether DOM 3 KeyboardEvent code support is being used.
    function BarcodeScannerHandler(submitDataFunc) {
        var _this = this;
        // Event handler method.  Handles the KeyDown event.
        this.keyDownHandler = function (event) {
            //////console.log(`onKeyDownHandler = ${event.key}`);
            _this.scannerInput.log("onKeyDownHandler");
            _this.scannerInput.log(event);
            if (event.defaultPrevented) {
                _this.scannerInput.log("defaultPrevented");
                return; // Should do nothing if the default action has been cancelled.
            }
            if (_this.dom3KeyboardEventCodeSupported) {
                _this.scannerInput.log("dom3KeyboardEventCodeSupported push");
                _this.scannerInput.push(event);
                if (event.code === "Enter" &&
                    event.ctrlKey === false &&
                    event.altKey === false &&
                    event.metaKey === false) {
                    // SUBMIT HERE
                    _this.submitData();
                }
                _this.setTimer();
                event.preventDefault();
            }
            else {
                // Handle numeric keypad input
                if (event.location === 3 && event.altKey === true) {
                    _this.scannerInput.log("Handle numeric keypad input true");
                    _this.keypadAltCharNumber += event.key;
                    _this.setTimer();
                    event.stopPropagation();
                    return;
                }
                else {
                    _this.scannerInput.log("Handle numeric keypad input else");
                    if (_this.keypadAltCharNumber.length > 0 && _this.browser.name !== "IE") {
                        _this.scannerInput.log("this.keypadAltCharNumber.length > 0 && this.browser.name !== IE");
                        _this.scannerInput.log("this.keypadAltCharNumber == " + _this.keypadAltCharNumber);
                        _this.scannerInput.log("numeric keypad input push");
                        _this.scannerInput.push(parseInt(_this.keypadAltCharNumber, 10));
                        _this.keypadAltCharNumber = "";
                    }
                }
                if (event.ctrlKey === false && (event.key === "Dead" || event.key === "Unidentified")) {
                    _this.scannerInput.log("event.ctrlKey === false && (event.key === \"Dead\" || event.key === \"Unidentified\")");
                    if (_this.scannerInput.peek() !== 0) {
                        _this.scannerInput.log("dead key push");
                        _this.scannerInput.push(0);
                    }
                }
                else if (event.ctrlKey === false && event.key === "Enter" && _this.browser.name === "IE") {
                    _this.scannerInput.log('event.ctrlKey === false && event.key === "Enter" && this.browser.name === "IE"');
                    _this.scannerInput.log("IE ENTER push");
                    _this.scannerInput.push(13);
                    // SUBMIT HERE
                    _this.submitData();
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                }
                else if (event.ctrlKey && event.key !== "Control") {
                    _this.scannerInput.log('event.ctrlKey && event.key !== "Control"');
                    if (_this.browser.name !== "Firefox" && event.key !== "Unidentified") {
                        _this.scannerInput.log('this.browser.name !== "Firefox" && event.key !== "Unidentified"');
                        var keyCode = void 0;
                        if (_this.browser.name === "Chrome" || _this.browser.name === "Opera") {
                            _this.scannerInput.log('this.browser.name === "Chrome" || this.browser.name === "Opera"');
                            keyCode = 0;
                            switch (event.code) {
                                case "Backslash":
                                    // ASCII 28
                                    event.preventDefault();
                                    keyCode = 28;
                                    break;
                                case "BracketRight":
                                    // ASCII 29
                                    event.preventDefault();
                                    keyCode = 29;
                                    break;
                                case "Digit6":
                                    // ASCII 30
                                    event.preventDefault();
                                    keyCode = 30;
                                    break;
                                case "Minus":
                                    // ASCII 31
                                    event.preventDefault();
                                    keyCode = 31;
                                    break;
                            }
                            _this.scannerInput.log("chrome/opera push");
                            _this.scannerInput.push(keyCode);
                        }
                        else {
                            _this.scannerInput.log('this.browser.name === "Chrome" || this.browser.name === "Opera" ELSE');
                            keyCode = 0;
                            switch (event.key) {
                                case "6":
                                    // ASCII 30
                                    keyCode = 30;
                                    break;
                            }
                            _this.scannerInput.log("chrome/opera else push");
                            _this.scannerInput.push(keyCode);
                        }
                    }
                    else if (_this.browser.name === "IE") {
                        _this.scannerInput.log('browser is IE');
                        switch (event.keyCode) {
                            case 220:
                            case 226:
                                // ASCII 28
                                _this.scannerInput.log("IE push");
                                _this.scannerInput.push(28);
                                break;
                            case 221:
                                // ASCII 29
                                _this.scannerInput.log("IE push");
                                _this.scannerInput.push(29);
                                break;
                            case 189:
                                // ASCII 31#
                                _this.scannerInput.log("IE push");
                                _this.scannerInput.push(31);
                                break;
                            default:
                                _this.scannerInput.log("IE push");
                                _this.scannerInput.push(0);
                                break;
                        }
                        event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    }
                    else {
                        _this.scannerInput.log('this.browser.name !== "Firefox" && event.key !== "Unidentified" ELSE push');
                        _this.scannerInput.push(0);
                        event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                    }
                }
            }
            event.stopPropagation();
        };
        // EVent handler method.  Handles the KeyUp event.
        this.keyUpHandler = function (event) {
            ////////console.log(`onKeyUpHandler = ${event.key}`);
            _this.scannerInput.log("onKeyUpHandler");
            _this.scannerInput.log(event);
            if (event.defaultPrevented) {
                _this.scannerInput.log("defaultPrevented");
                return; // Should do nothing if the default action has been cancelled.
            }
            if (_this.dom3KeyboardEventCodeSupported) {
                _this.scannerInput.log("dom3KeyboardEventCodeSupported");
                if (event.code === "AltLeft") {
                    _this.scannerInput.log('event.code === "AltLeft" push');
                    _this.scannerInput.push(event);
                }
                event.preventDefault();
            }
        };
        // Event handler method.  Handles the KeyPress event.
        this.keyPressHandler = function (event) {
            ////////console.log(`onKeyPressHandler = ${event.key}`);
            _this.scannerInput.log("onKeyPressHandler");
            _this.scannerInput.log(event);
            if (_this.dom3KeyboardEventCodeSupported) {
                _this.scannerInput.log("dom3KeyboardEventCodeSupported");
                if (event.defaultPrevented) {
                    _this.scannerInput.log("defaultPrevented");
                    return; // Should do nothing if the default action has been cancelled
                }
            }
            else {
                _this.scannerInput.log("dom3KeyboardEventCodeSupported ELSE");
                _this.setTimer();
                var keyCode = Number(event.charCode);
                if (event.key !== undefined) {
                    _this.scannerInput.log("event.key !== undefined");
                    if (event.key.length > 1) {
                        _this.scannerInput.log("event.key.length > 1");
                        if (event.key === "Unidentified" || event.key === "Enter") {
                            _this.scannerInput.log('event.key === "Unidentified" || event.key === "Enter"');
                            if (_this.scannerInput.inputCharArray.length > 0 && _this.scannerInput.peek() === 0) {
                                _this.scannerInput.log("this.scannerInput.inputCharArray.length > 0 && this.scannerInput.peek() === 0 pop");
                                _this.scannerInput.pop();
                            }
                            if (_this.browser.name === "Firefox") {
                                _this.scannerInput.log('this.browser.name === "Firefox"');
                                keyCode = Number(event.keyCode);
                            }
                            _this.scannerInput.log('event.key === "Unidentified" || event.key === "Enter" PUSH');
                            _this.scannerInput.push(keyCode);
                            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                            if (event.key === "Enter") {
                                // SUBMIT HERE
                                _this.submitData();
                            }
                        }
                        else {
                            _this.scannerInput.log('event.key === "Unidentified" || event.key === "Enter" ELSE');
                            if (_this.browser.name === "IE") {
                                _this.scannerInput.log("Browser is IE Push");
                                _this.scannerInput.push(keyCode);
                                event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                            }
                            else {
                                _this.scannerInput.log("Browser is not IE");
                                for (var i = 0; i < event.key.length; i++) {
                                    _this.scannerInput.log("Browser is not IE Push part of key");
                                    _this.scannerInput.push(event.key.charCodeAt(i));
                                }
                            }
                        }
                    }
                    else {
                        _this.scannerInput.log("event.key.length > 1 ELSE");
                        if ((_this.browser.name === "Chrome" || _this.browser.name === "Opera") &&
                            event.ctrlKey &&
                            Number(keyCode) < 32) {
                            _this.scannerInput.log('(this.browser.name === "Chrome" || this.browser.name === "Opera") && event.ctrlKey && Number(keyCode) < 32');
                            if (_this.scannerInput.inputCharArray.length > 0) {
                                _this.scannerInput.log("this.scannerInput.inputCharArray.length > 0");
                                var lastValue = _this.scannerInput.peek();
                                switch (lastValue) {
                                    case 0:
                                        _this.scannerInput.log("last value is 0 pop");
                                        _this.scannerInput.pop();
                                        break;
                                    case 28:
                                    case 29:
                                    case 30:
                                    case 31:
                                        _this.scannerInput.log("last value is 28/29/30/31 pop");
                                        event.preventDefault();
                                        _this.scannerInput.pop();
                                        break;
                                }
                            }
                        }
                        if (_this.browser.name === "Firefox" && event.ctrlKey) {
                            _this.scannerInput.log('this.browser.name === "Firefox" && event.ctrlKey');
                            var stripZero = false;
                            switch (keyCode) {
                                case 36:
                                    // ASCII 28
                                    event.preventDefault();
                                    stripZero = true;
                                    keyCode = 28;
                                    break;
                                case 168:
                                    // ASCII 29
                                    event.preventDefault();
                                    stripZero = true;
                                    keyCode = 29;
                                    break;
                                case 54:
                                    // ASCII 30
                                    event.preventDefault();
                                    stripZero = true;
                                    keyCode = 30;
                                    break;
                                case 39:
                                    // ASCII 31
                                    event.preventDefault();
                                    stripZero = true;
                                    keyCode = 31;
                                    break;
                            }
                            if (stripZero) {
                                _this.scannerInput.log("stripZero");
                                if (_this.scannerInput.inputCharArray.length > 0 && _this.scannerInput.peek() === 0) {
                                    _this.scannerInput.log('this.scannerInput.inputCharArray.length > 0 && this.scannerInput.peek() === 0 Pop');
                                    _this.scannerInput.pop();
                                }
                            }
                        }
                        _this.scannerInput.log("event.key.length > 1 ELSE push");
                        _this.scannerInput.push(keyCode);
                        _this.keypadAltCharNumber = "";
                    }
                }
            }
        };
        // Submit the data read by the barcode scanner.
        this.submitData = function () {
            clearTimeout(_this.submitDataTimerId);
            if (Services_1.EventHandlerProvider.GetInstance().GetEvent() == null) {
                if (_this.dom3KeyboardEventCodeSupported) {
                    _this.doSubmitData(true);
                }
                else {
                    _this.doSubmitData(false);
                }
                _this.scannerInput.persistLogs();
            }
            _this.scannerInput.clear();
        };
        // Set a time to automatically submit data entry if the barcode scanner does not emit carriage returns.
        this.setTimer = function () {
            if (_this.submitDataTimerId) {
                clearTimeout(_this.submitDataTimerId);
            }
            _this.submitDataTimerId = window.setTimeout(_this.submitData, 300);
        };
        this.scannerInput = new ScannerInput_1.ScannerInput("!\"%&'()*+,-./0123456789:;<=>?ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz]" + String.fromCharCode(29));
        this.doSubmitData = submitDataFunc;
        this.browser = Util_1.saysWho();
        if (calibrationOnCharacters) {
            this.dom3KeyboardEventCodeSupported = false;
        }
        else {
            this.dom3KeyboardEventCodeSupported = (this.browser.name === "Chrome" && this.browser.version >= 48) ||
                (this.browser.name === "Firefox" && this.browser.version >= 38) ||
                (this.browser.name === "Opera" && this.browser.version >= 35) ||
                (this.browser.name === "Safari" && this.browser.version >= 10.1);
        }
        this.keypadAltCharNumber = "";
        this.submitDataTimerId = 0;
    }
    return BarcodeScannerHandler;
}());
exports.BarcodeScannerHandler = BarcodeScannerHandler;
//# sourceMappingURL=BarcodeScannerHandler.js.map